module.exports = __webpack_public_path__ + "static/consultbanner-7953dcd57453bc881b9e3468cee2b25d.png";